export const BrandMark = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 48 48"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="48" height="48" rx="13" fill="#B44226" />
    <path
      d="M8 32h8l6-6h5l8-8h5"
      stroke="#FFFDF8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <circle cx="8" cy="32" r="2" fill="#F4C36B" />
    <circle cx="16" cy="32" r="2" fill="#FFFDF8" />
    <circle cx="22" cy="26" r="2" fill="#FFFDF8" />
    <circle cx="27" cy="26" r="2" fill="#FFFDF8" />
    <circle cx="35" cy="18" r="2" fill="#F4C36B" />
    <path d="m25 9-7 12h6l-2 11 10-15h-6l2-8h-3Z" fill="#FFFDF8" />
  </svg>
);

export default BrandMark;
